import React from 'react';
import DefaultHeader from './DefaultHeader';
import SelectRow from './SelectRow';
import Pagination from './Pagination';
import emptyTableImage from '../../assets/images/admin/empty_table.svg';
import { CircularProgress } from '@material-ui/core';

const Table = ({
    HeaderComponent = DefaultHeader,
    RowComponent = SelectRow,
    smallColumns = [],
    largeColumns = [],
    scroll=false,
    ...props
}) => {
    return (
        <React.Fragment>
            {props.loading ? (
                <div className="ckp-tables-loading">
                    <div className="ckp-tables-loading-content">
                        <span className="ckp-tables-loading-label">{props.loading}</span>
                        <CircularProgress className={`ckp-loading-spinner`} size={30} />
                    </div>
                </div>
            ) : null}
            <div className={scroll? "ckp-tables-scroll" : "ckp-tables"}>
                <table className={`ckp-tables ${props.disabled ? 'is-disabled' : ''} ${props.className || ''}`}>
                    <HeaderComponent
                        smallColumns={smallColumns}
                        largeColumns={largeColumns}
                        changeSort={props.changeSort}
                        sort={props.sort}
                        sortDirection={props.sortDirection}
                        columns={props.headers}
                        selectable={!props.noSelect}
                        selectAll={props.selectAll}
                        selectAllChecked={props.selectAllChecked}
                    />
                    {props.loading ? null : (
                        <tbody className={`ckp-tables-body ${props.maxHeight ? 'is-with-scroll' : ''}`}>
                            {props.data.length ? (
                                props.data.map((item, index) => (
                                    <RowComponent
                                        disableTooltip={props.disableTooltip}
                                        smallColumns={smallColumns}
                                        largeColumns={largeColumns}
                                        enableRowFunction={props.enableRowFunction}
                                        enableSelectFunction={props.enableSelectFunction}
                                        allowOpen={props.canOpenRows}
                                        transformFunctions={props.transformFunctions}
                                        highlightFunction={props.highlightFunction}
                                        key={item.id || index}
                                        selected={props.isSelected && props.isSelected(item)}
                                        onSelect={props.onSelect}
                                        onOpen={props.onOpen}
                                        selectable={!props.noSelect}
                                        item={item}
                                        fields={props.headers}
                                    />
                                ))
                            ) : (
                                <tr className="ckp-tables-empty-tr">
                                    <td className="ckp-tables-empty-td">
                                        <img alt="Empty Table" src={emptyTableImage} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>
            {props.pagination & !props.loading ? (
                <Pagination
                    paginationChange={props.paginationChange}
                    resultsPerPage={props.resultsPerPage}
                    currentPage={props.currentPage}
                    totalPages={props.totalPages}
                />
            ) : null}
        </React.Fragment>
    );
};
export default Table;



// WEBPACK FOOTER //
// ./src/components/tables/Table.js